module.exports = __webpack_public_path__ + "static/media/sc_19_i.87af2ba7.png";